import axios from './axios';

// Verify User Authentication
export const verifyUserAuthentication = () => {
  return axios.get(`/auth/whoami`, {withCredentials: true});
};

// Logout User
// export const logoutUser = () => {
//   return axios.get(`/auth/logout`, {withCredentials: true});
// };

export const fetchAllUsers = () => axios.get("/api/qli/admin/users");

export const fetchUserDownloadLog = (userId) =>
  axios.get(`/api/qli/admin/download-log/${userId}`);

// Fetch S3 Buckets
export const fetchS3Buckets = () => {
  return axios.get(`/api/qli/buckets`);
};

// Fetch Items from S3 Bucket
export const fetchS3BucketItems = (bucketName, prefix) => {
  const encodedBucketName = encodeURIComponent(bucketName);
  const encodedPrefix = prefix ? prefix.split("/").map((s) => encodeURIComponent(s)).join("/") : '';
  if (encodedPrefix) {
    return axios.get(`/api/qli/buckets/${encodedBucketName}/objects?prefix=${encodedPrefix}`);
  }
  return axios.get(`/api/qli/buckets/${encodedBucketName}/objects`);
};

// Fetch Download Details from S3 Bucket
export const fetchDownloadItemS3Bucket = (bucketName, key, prefix, presign = false) => {
  const encodedBucketName = encodeURIComponent(bucketName);
  const encodedKey = encodeURIComponent(key);
  const encodedPrefix = prefix ? prefix.split("/").map((s) => encodeURIComponent(s)).join("/") : '';
  if (encodedPrefix) {
    return axios.get(`/api/qli/buckets/${encodedBucketName}/download?key=${encodedKey}&prefix=${encodedPrefix}&presign=${presign}`);
  }
  return axios.get(`/api/qli/buckets/${encodedBucketName}/download?key=${encodedKey}&presign=${presign}`);
};

// Server Side Search
export const fetchS3BucketSearchItems = (bucketName, searchTerm, prefix, folder_search = false) => {
  const encodedBucketName = encodeURIComponent(bucketName);
  const encodedSearchTerm = encodeURIComponent(searchTerm);
  const encodedPrefix = prefix ? prefix.split("/").map((s) => encodeURIComponent(s)).join("/") : '';
  if (encodedPrefix) {
    return axios.get(`/api/qli/buckets/${encodedBucketName}/search?q=${encodedSearchTerm}&prefix=${encodedPrefix}&folder=${folder_search}`);
  }
  return axios.get(`/api/qli/buckets/${encodedBucketName}/search?q=${encodedSearchTerm}&folder=${folder_search}`);
};

// Fetch S3 Bucket Release Notes
export const fetchS3BucketReleaseNotes = (bucketName) => {
  return axios.get(`/api/qli/admin/release-notes/${encodeURIComponent(bucketName)}`);
}

// Fetch Release Notes
export const fetchAllReleaseNotes = () => {
  return axios.get(`/api/qli/admin/release-notes`);
}

// Create Notes
export const createOrUpdateNewReleaseNotes = (payload) => {
  return axios.post(`/api/qli/admin/release-notes`, payload)
};

// Fetch Release Notes Buckets List
export const fetchReleaseNotesBucketsList = () => {
  return axios.get(`/api/qli/admin/release-notes/buckets/dropdown`)
};

// Delete Notes
export const deleteReleaseNotes = (id) => {
  return axios.delete(`/api/qli/admin/release-notes/${id}`)
};

// Fetch Tokens
export const fetchAllValidTokens = () => {
  return axios.get(`/api/qli/admin/tokens`);
}

// Fetch Tokens by User ID
export const fetchTokensByUserId = (userId) => {
  return axios.get(`/api/qli/admin/tokens/${userId}`);
};

// Create Token
export const createNewToken = (payload) => {
  return axios.post(`/api/qli/admin/token`, payload)
};

// Revoke Token
export const revokeExistedToken = (payload) => {
  return axios.post(`/api/qli/admin/token/revoke`, payload)
};

// Rotate Token
export const rotateExistedToken = (payload) => {
  return axios.post(`/api/qli/admin/token/rotate`, payload)
}

// Fetch Bucket Access Lists
export const fetchAllBucketAccessLists = () => {
  return axios.get(`/api/qli/admin/bucket-access-lists`);
}

// Create Bucket Access Lists
export const createOrUpdateNewBucketAccessLists = (payload) => {
  return axios.post(`/api/qli/admin/bucket-access-lists`, payload)
};

// Fetch Bucket Access Buckets List
export const fetchBucketAccessBucketsList = () => {
  return axios.get(`/api/qli/admin/bucket-access-lists/buckets/dropdown`)
};

// Delete Bucket Access Lists
export const deleteBucketAccessLists = (id) => {
  return axios.delete(`/api/qli/admin/bucket-access-lists/${id}`)
};

// Fetch Bucket Access Roles
export const fetchAllTokenBucketAccess = () => {
  return axios.get(`/api/qli/admin/token-bucket-access`);
};

// Fetch User Bucket Access Roles
export const fetchUserTokenBucketAccess = (userId) => {
  return axios.get(`/api/qli/admin/token-bucket-access?user_id=${userId}`);
};

// Fetch Tokens List For Bucket Access
export const fetchAllTokenBucketAccessTokensList = () => {
  return axios.get(`/api/qli/admin/token-bucket-access/tokens/dropdown`);
};

// Fetch User Tokens List For Bucket Access
export const fetchUserTokenBucketAccessTokensList = (userId) => {
  return axios.get(`/api/qli/admin/token-bucket-access/tokens/dropdown?user_id=${userId}`);
};

// Fetch Buckets List For Bucket Access
export const fetchTokenBucketAccessBucketsList = () => {
  return axios.get(`/api/qli/admin/token-bucket-access/buckets/dropdown`);
};

// Create Bucket Access Role
export const createTokenBucketAccess = (tokenId, payload) => {
  return axios.post(`/api/qli/admin/token-bucket-access/${tokenId}`, payload);
};

// Update Bucket Access Role
export const updateTokenBucketAccess = (tokenId, payload) => {
  return axios.put(`/api/qli/admin/token-bucket-access/${tokenId}`, payload);
};

// Delete Bucket Access Role
export const deleteTokenBucketAccess = (tokenId) => {
  return axios.delete(`/api/qli/admin/token-bucket-access/${tokenId}`);
};
